import arLocale from 'element-ui/lib/locale/lang/ar' //引入element语言包
const ar = {
  posterPage: {
    title1:'الاشتراك على الانترنت !',
    title2:'تجديد الاشتراك ، امتياز الترقية !',
    title3:'خصم خاص ، تجديد أكثر فعالية من حيث التكلفة',
    title4:'للحصول على رمز التبديل ، يمكنك استشارة البائع لشراء المعدات',
    title5:'يفضل تجربة وظيفة',
    function1:'تفاصيل الوظيفة :',
    function2:'تجديد الخدمات الأساسية ( الترجمة الفورية ، مساعد المؤتمر ، مساعد ذكي ) .',
    function3:'الخدمات ذات القيمة المضافة الاشتراك ( حاليا الترجمة ، الترجمة السمعية والبصرية ) .',
  },
  RedemptionCodePage: {
    RedemptionCode: 'تبادل رمز',
    ValueAddedServices: 'خدمات القيمة المضافة',
    UpgradedExperience: 'حصريا حقوق القيمة المضافة ، تجربة الترقية',
    OfflineTranslation: 'الترجمة غير متصل',
    NoInternet: 'لا تحتاج إلى شبكة الإنترنت ، الترجمة الفورية ، آمنة وموثوق بها',
    GoToSubscribe: 'الذهاب والاشتراك',
    AudioAndVideoCall: 'مكالمات صوتية / فيديو',
    RealTimeCall: 'في الوقت الحقيقي ترجمة الكلام والاتصال دون عائق',
    BaseService: 'الخدمات الأساسية',
    AIAssistant: 'الترجمة الفورية ، مساعد مؤتمر منظمة العفو الدولية مساعد',
    LanguagesSetting:'إعدادات اللغة',
    languages1:'الصينية المبسطة',
    languages2:'الصينية التقليدية',
    languages3:'english 2',
    languages4:'اليابانية .',
    languages5:'كوري',
    languages6:'روسي',
    languages7:'إسبانية',
    languages8:'الفرنسية .',
    languages9:'ألماني',
    languages10:'البرتغالية',
    languages11:'الايطالية',
    languages12:'اللغة التركية',
    languages13:'الفيتنامية',
    languages14:'الإندونيسية',
    languages15:'هندي',
    languages16:'بالعربية',
    languages17:'التايلاندية',
    languages18:'فارسي',
  },
  Login: {
    ToLogin: 'سجل',
    PhoneLogin: 'رقم الهاتف',
    EmailLogin: 'تسجيل الدخول',
    PhonePlaceholder: 'الرجاء إدخال رقم الهاتف',
    EmailPlaceholder: 'Enter email',
    Code: 'رمز التحقق',
    and: 'و .',
    BeforeText: 'إنشاء حساب باسم موافقتك والالتزام',
    UserAgreement: 'بروتوكول المستخدم',
    privacy: 'سياسة الخصوصية',
    errorMessage: 'رمز التحقق من الخطأ',
    readTitle: 'قراءة والموافقة على الاتفاق التالي',
    readBefore: 'لضمان أمن المعلومات الشخصية الخاصة بك ، يرجى قراءة والموافقة على',
    cancel: 'ألغى',
    agree: 'الموافقة على الاستمرار',
    error1:'الرجاء إدخال عنوان بريد إلكتروني صالح',
    error2:'الرجاء إدخال رقم الهاتف الصحيح',
    error3:'الرجاء إدخال رمز التحقق',
    success:'تسجيل الدخول بنجاح'
  },
  OffLinePage: {
    title: 'الترجمة غير متصل',
    NoInternet: 'لا تحتاج إلى شبكة الإنترنت ، الترجمة الفورية ، آمنة وموثوق بها',
    ServiceLife: 'مدة الاستخدام',
    forever: 'الاستخدام الدائم',
    describe: 'وصف الاشتراك',
    describeItem1: '1 . غير متصل وظيفة الترجمة هو الدفع لمرة واحدة ، واستخدام دائم ، واستخدام إذن لمتابعة جهاز بلوتوث ، إذا كان استبدال الجهاز ، تحتاج إلى إعادة الاشتراك في الترجمة غير متصل رمز التبديل .',
    describeItem2: '2 - لا يمكن استرداد رسوم الاشتراك بعد إذن رمز .',
    describeItem3: 'دعم 10 لغات : الصينية ، الإنجليزية ، الألمانية ، اليابانية ، الكورية ، الهندية ، التايلاندية ، الإسبانية ، الفرنسية ، الروسية .',
    quantity: 'الكمية',
    payType: 'طريقة الدفع',
    card: 'بطاقة مصرفية',
    wx: 'رسالة صغيرة',
    GooglePay: 'Google Pay',
    subscribe: 'اشترك',
    RMB: '¥',
    confirm:'أكّد',
    cardNumber:'رقم البطاقة',
    periodOfValidity:'فترة الصلاحية',
    safetyCode:'رمز الأمان',
    name:'الاسم الكامل',
    yearAndMonth:'السنة / الشهر',
    message1:'الكمية لا يمكن أن يكون 0',
    popTip:'نصائح دافئة',
    popText1:'يرجى قراءة وفهم',
    popText2:'حاليا دفع بروتوكول الترجمة',
    popText3:'لقد قرأت ووافقت',
    popText4:'قرأت ووافقت',
  },
  AudioVideoPage: {
    title: 'مكالمات صوتية / فيديو',
    RealTime: 'في الوقت الحقيقي ترجمة الكلام والاتصال دون عائق',
    describe: 'وصف الاشتراك',
    describeItem1: '1 . الصوت والفيديو وظيفة الترجمة هو شحن شراء دقائق ، دقائق من بدء الاتصال على حساب طول الوقت ، إذن لمتابعة الحساب ، إذا كان تسجيل الدخول إلى حسابات أخرى ، تحتاج إلى إعادة شحن .',
    describeItem2: '2 - ربط وربط أجهزة مختلفة يمكن استخدامها كالمعتاد بعد شحن الحساب .',
    describeItem3: '3 . الصوت والفيديو وظيفة الترجمة لا يمكن ردها بعد الشحن .',
    payType: 'طريقة الدفع',
    card: 'بطاقة مصرفية',
    wx: 'رسالة صغيرة',
    GooglePay: 'Google Pay',
    subscribe: 'اشترك',
    RMB: '¥',
    sale: 'خصومات',
    confirm:'أكّد',
    time1:'ثانية .',
    time2:'دقيقة .',
    time3:'ساعة .',
    time4:'أيام .',
    time5:'شهر .',
    time6:'سنة',
  },
  OffLineResult: {
    title1: 'الترجمة غير متصل',
    title2: 'مكالمات صوتية / فيديو',
    title3: 'الخدمات الأساسية',
    success: 'الاشتراك بنجاح',
    fail: 'فشل الاشتراك',
    stock:'رمز التبديل',
    saveTitle: 'حفظ رمز التبديل ، والذهاب إلى التطبيق',
    code: 'تبادل رمز',
    tip1: 'هذا الكود يستخدم فقط لتحويل وظائف الترجمة غير متصل',
    tip2: 'هذا الكود يستخدم فقط لتحويل الصوت / الفيديو وظيفة الترجمة',
    tip3: 'هذا الكود يستخدم فقط من أجل تجديد وظيفة تبادل الخدمات الأساسية',
    save: 'حفظ .',
    time: 'وقت الاشتراك :',
    copy: 'نسخ',
    copySuccess: 'نسخة ناجحة',
    loading:'تحميل',
    paySuccess:'دفع النجاح'
  },
  RedemptionList: {
    title: 'بلدي رقم الصرف',
    view: 'عرض .',
    time: 'وقت الاشتراك :',
  },
  MyRedemption: {
    title: 'بلدي رقم الصرف',
    code: 'تبادل رمز',
    time: 'وقت الاشتراك :',
    copy: 'نسخ',
    tip1: 'هذا الكود يستخدم فقط لتحويل وظائف الترجمة غير متصل',
    tip2: 'هذا الكود يستخدم فقط لتحويل الصوت / الفيديو وظيفة الترجمة',
    tip3: 'هذا الكود يستخدم فقط من أجل تجديد وظيفة تبادل الخدمات الأساسية',
    save: 'حفظ .',
    success:"عملية ناجحة"
  },
  basePage:{
    error1:'لا معلومات المنتج',
    message1:'الرجاء اختيار السلع',
    title:'الخدمات الأساسية',
    function:'الترجمة الفورية ، مساعد مؤتمر منظمة العفو الدولية مساعد',
    describe: 'وصف الاشتراك',
    describe1:'1 - بعد تجديد الخدمات الأساسية ، مثل الترجمة الفورية ، مساعد المؤتمرات ، وما إلى ذلك ، يجب أن تكون المعدات التالية صالحة لفترة من الوقت .',
    describe2:'2 - لا يجوز استرداد رسوم تجديد الخدمات الأساسية .',
    payType: 'طريقة الدفع',
    card: 'بطاقة مصرفية',
    wx: 'رسالة صغيرة',
    GooglePay: 'Google Pay',
    subscribe: 'اشترك',
    RMB: '¥',
    sale: 'خصومات',
    month:'شهر .',
    confirm:'أكّد',
    month1:'شهر',
    month2:'نصف سنة',
    month3:'سنة'
  },
  ...arLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default ar;
